'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_Endpoints$Documents$ReadInput(id, filename, gotenbergSecret) {
  this.a6M = null;
  this.a6K = null;
  this.a6L = null;
  this.a6M = id;
  this.a6K = filename;
  this.a6L = gotenbergSecret;
}
export { $c_Lapp_Endpoints$Documents$ReadInput as $c_Lapp_Endpoints$Documents$ReadInput };
$p = $c_Lapp_Endpoints$Documents$ReadInput.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_Endpoints$Documents$ReadInput;
/** @constructor */
function $h_Lapp_Endpoints$Documents$ReadInput() {
}
export { $h_Lapp_Endpoints$Documents$ReadInput as $h_Lapp_Endpoints$Documents$ReadInput };
$h_Lapp_Endpoints$Documents$ReadInput.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_Endpoints$Documents$ReadInput)) {
    var x = this.a6M;
    var x$2 = x$0.a6M;
    if ((((x === null) ? (x$2 === null) : x.f(x$2)) && (this.a6K === x$0.a6K))) {
      var x$3 = this.a6L;
      var x$4 = x$0.a6L;
      return ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 3;
});
$p.t = (function() {
  return "ReadInput";
});
$p.e = (function(n) {
  switch (n) {
    case 0: {
      return this.a6M;
      break;
    }
    case 1: {
      return this.a6K;
      break;
    }
    case 2: {
      return this.a6L;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.u = (function(n) {
  switch (n) {
    case 0: {
      return "id";
      break;
    }
    case 1: {
      return "filename";
      break;
    }
    case 2: {
      return "gotenbergSecret";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lapp_Endpoints$Documents$ReadInput(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ib)));
}
export { $isArrayOf_Lapp_Endpoints$Documents$ReadInput as $isArrayOf_Lapp_Endpoints$Documents$ReadInput };
var $d_Lapp_Endpoints$Documents$ReadInput = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_Endpoints$Documents$ReadInput, "app.Endpoints$Documents$ReadInput", ({
  ib: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_Endpoints$Documents$ReadInput as $d_Lapp_Endpoints$Documents$ReadInput };
//# sourceMappingURL=app.-Endpoints$-Documents$-Read-Input.js.map
